import { type ClassValue, clsx } from "clsx";

export function cn(...inputs: ClassValue[]) {
	return clsx(inputs);
}

export function delay(ms: number) {
	return new Promise((r) => setTimeout(r, ms));
}
